export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const APP_PARENT_URL = process.env.REACT_APP_APP_PARENT_URL;
export const API_BE4FE_URL = process.env.REACT_APP_API_BE4FE_URL;
export const FEATURE_TOGGLE_DEV = process.env.REACT_APP_FEATURE_TOGGLE_DEV;
export const API_MODEBIS_CONFIG_WRITE_URL =
    process.env.REACT_APP_API_MODEBIS_CONFIG_WRITE_URL;
export const API_MODEBIS_CONFIG_READ_URL =
    process.env.REACT_APP_API_MODEBIS_CONFIG_READ_URL;
export const API_MODESETTINGS_URL = process.env.REACT_APP_API_MODESETTINGS_URL;
export const APP_GAINSIGHT_TAG_KEY = process.env.REACT_APP_GAINSIGHT_TAG_KEY;
export const APP_ONE_TRUST_ENABLED = process.env.REACT_APP_ONE_TRUST_ENABLED;
export const USE_DEV_CREDENTIALS =
    process.env.REACT_APP_API_BE4FE_URL === "http://localhost:3456";

export const DEV_PARENT_APP_PARAMS = {
    user: {
        token: "userFakeToken",
        id: "userFakeId",
    },
    item:
        Math.random() > 0.5
            ? {
                  id: "companyFakeItemId",
                  classifier: "COMPANY",
              }
            : {
                  id: "studioFakeItemId",
                  classifier: "STUDIO",
              },
    cookieConsents: {
        C0006: true,
    },
};
